<template>
  <div class="row align-items-center">
    <div class="number-input p-0">
      <button @click="amountData > 0 ? amountData-- : amountData = 0" class="minus"></button>
      <input class="quantity" min="0" name="quantity" type="number" v-model.trim="amountData">
      <button @click="amountData < maxValue ? amountData++ : ''" class="plus" :disabled="amountData == maxValue"></button>
    </div>
    <div class="ml-2 pl-3">
      <button class="btn generalTertiaryButton" v-if="amountData > 0 && amountData <= maxValue"
        @click="added ? changeProductBusiness() : selectProductBusiness()">{{ added ? 'Guardar' : 'Añadir' }}</button>
    </div>
    <div class="ml-4 pl-3" v-bind:class="{ 'btnHidden': !added }">
      <button class="deleteButton" @click="deleteProductBusiness()">Eliminar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: [
    'added',
    'amount',
    'maxValue'
  ],
  data() {
    return {
      amountData: this.amount,
      changing: false
    }
  },
  watch: {
    amount(newValue, oldValue) {
      console.log(oldValue)
      this.amountData = newValue
    }
  },
  methods: {
    selectProductBusiness() {
      this.$emit('selectProductBusiness', { amount: this.amountData });
    },
    changeProductBusiness() {
      this.changing = false
      this.$emit('changeProductBusiness', { amount: this.amountData });
    },
    deleteProductBusiness() {
      this.amountData = 0
      this.$emit('deleteProductBusiness');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.number-input input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

.number-input input[type=number]::-webkit-inner-spin-button,
.number-input input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.number-input {
  display: flex;
  justify-content: space-around;
  align-items: left;
}

.number-input button {
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 10px 0;
  position: relative;
}

.number-input button:before,
.number-input button:after {
  display: inline-block;
  position: absolute;
  content: '';
  height: 2px;
  transform: translate(-50%, -50%);
}

.number-input button.plus:after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.number-input input[type=number] {
  text-align: center;
}

.number-input.number-input {
  border: 1px solid #ddd;
  width: 9rem;
  border-radius: .25rem;
}

.number-input.number-input button {
  width: 1.5rem;
  height: .5rem;
}

.number-input.number-input button.minus {
  padding-left: 12px;
}

.number-input.number-input button.plus {
  padding-right: 12px;
}

.number-input.number-input button:before,
.number-input.number-input button:after {
  width: .9rem;
  background-color: #495057;
}

.number-input.number-input input[type=number] {
  max-width: 3rem;
  padding: .5rem;
  border: 1px solid #ddd;
  border-width: 0 1px;
  font-size: 1rem;
  height: 2rem;
  color: #495057;
}

.divRow {
  width: 12rem;
  max-width: 12rem;
  height: 3rem;
  max-height: 3rem;
}

.deleteButton {
  padding: 8px;
  text-transform: uppercase;
  border-radius: 0;
  background-color: white;
  color: #464646;
  border-color: #464646;
  line-height: 1.75;
  border: 1px solid #464646;

  &:hover {
    color: #464646;
    background-color: #e5e4e4;
    border-color: #464646;
    border: 1px solid #e5e4e4;
  }

  &:focus {
    box-shadow: none;
  }
}

.btnHidden {
  opacity: 0;
  pointer-events: none;
}
</style>
